<template>
    <div class="bedone">
        <div class="bedone_cennert">
            <h1>我们能为你做什么？</h1>
            <p>具有高度互动体验的虚拟现实的体验环境</p>
            <ul>
                <li><span>·</span>线上展览交易会</li>
                <li><span>·</span>VR企业展厅</li>
                <li><span>·</span>VR党建文博展馆</li>
                <li><span>·</span>VR产业园区</li>
            </ul>
<div data-aos="zoom-in">
            <div class="bedone_video">
                 <img  id="bedone_video_bg" src="../../assets/imges/scheme/scheme_vidoe.png"/>
                   <img  @click="bedonevideo_play" id="video_play" v-if="!bedonevideo" src="https://oss.3dyunchuang.com/home_pic/video/vr_expo.jpg"/>
                     <div class="suspend" @click="bedonevideo_play" v-if="!bedonevideo">
                                <img src="../../assets/imges/suspend.png"/>
                        </div>
                 <video v-if="bedonevideo" style="object-fit: fill; background: #000000;" id="vio" width="100%" height="100%" controls="controls" autoplay="autoplay">
                        <source src="https://oss.3dyunchuang.com/home_pic/video/vr_expo.mp4" type="video/mp4">
                </video>
            </div>
</div>
        </div>
    </div>
</template>
<script>
export default {
 data() {
        return {
            bedonevideo:false
        }
 },
 methods:{
   bedonevideo_play(){
       this.bedonevideo = true
   }
  }
}
</script>
<style scoped>
.bedone{
    width: 100%;
    height: 982px;
    background: url("../../assets/imges/scheme/why_bg.png") no-repeat center;
}
.bedone_cennert{
    width: 1202px;
    height: 100%;
    margin: 0 auto;
}
.bedone_cennert h1{
    font-size: 36px;
    letter-spacing:1px;
    text-align: center;
    padding-top: 80px;
    margin-bottom: 5px;
    margin-left: 17px;
}
.bedone_cennert P{
    font-size: 20px;
    color: #666666;
    text-align: center;
    margin-bottom: 50px;
}
.bedone_cennert ul{
    width: 610px;
    height: 25px;
    margin: 0 auto;
}
.bedone_cennert ul li{
    float: left;
    font-size: 18px;
    margin-right: 15px;
    font-weight: bold;
    letter-spacing:1px;
}
.bedone_cennert ul li span{
    color: #357eff;
    margin-right: 8px;
}
.bedone_video{
    width: 953px;
    height: 522px;
    text-align: center;
    cursor: pointer;
    position:relative;
    margin: 28px auto;
}
.bedone_video #video_play{
    width: 958px;
    height: 525px;
    margin-top: 25px;
    position: absolute;
    left: 20px;
    top: 0;
}
.suspend{
    position: absolute;
    left: 53%;
    top: 52%;
    z-index: 9;
    transform: translate(-50%,-50%);
    width: 91px;
    height: 91px;
}
.bedone_video #bedone_video_bg{
    width: 995px;
    height: 570px;
    border-radius: 20px;
    box-shadow: 1px 6px 15px rgba(0,0,0,.5);
}
#vio{
    position: absolute;
    left: 22px;
    top: 25px;
 
}
</style>


// WEBPACK FOOTER //
// src/common/scheme/scheme-done.vue